import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { SetAccessment, UpdateAccessmentError } from "./AccessmentActions";
import { useLocation, useParams } from "react-router";
// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Assessment(props) {
  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);
  console.log("gloval data", globaluserData);

  const { type_of_assessments, assessment_clients } = useSelector(
    (state) => state.accessmentReducer.data
  );

  const type_of_assessmentSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.type_of_assessments
  );

  const errors = useSelector((state) => state.accessmentReducer.errors);

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      if (item.value || item.inputValue || item.selectValue) {
        item.value && (formData[item.name] = item.value);
        item.inputValue && (formData[item.inputName] = item.inputValue);
        item.selectValue && (formData[item.selectName] = item.selectValue);
        dispatch(SetAccessment(formData));
      }
    });
    dispatch(UpdateAccessmentError(updatedForm[index].name));
  };
  const userRole = globaluserData?.role;
  const isMandatory = userRole === "employee";

  // Form disabling
  const location = useLocation();

  const organisation_id = globaluserData?.organisation_id;
  const employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };
  const formArray = [
    {
      componentType: "multiSelectChip",
      type: "text",
      label: isMandatory ? "Types of assessment*" : "Types of assessment",
      errors: errors.type_of_assesments,

      helperText:
        errors.type_of_assessments &&
        "Please enter Facilitation Areas of Expertise",
      name: "type_of_assessments",
      placeholder: "Types of assessment",
      handleChange: handleInputChange,
      value: type_of_assessments,
      itemArr: type_of_assessmentSelector,
      // dropDown: 'TypeOfAssessment',
      // field_name: 'type_of_assessment',
    },
    {
      componentType: "input",
      type: "text",
      label: isMandatory ? "Assessment clients*" : "Assessment clients",
      errors: errors.assessment_clients,
      helperText:
        errors.assessment_clients && "Please enter Assessment Clients",
      name: "assessment_clients",
      multiline: true,
      placeholder: "Assessment clients",
      handleChange: handleInputChange,
      value: assessment_clients,
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}
